import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const Info = ({name, icon}) => {
  return (
    <p className="flex items-center gap-2">
      <FontAwesomeIcon icon={icon} className="text-gray-500" />
      <span className="font-medium text-gray-700">
        {name}
      </span>
    </p>
  );
};

export default Info;
